import { FC } from 'react';
import styled from 'styled-components';
import { FaExclamationTriangle } from 'react-icons/fa';
import Button from 'components/Button';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundScreen: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Wrapper>
      <FaExclamationTriangle
        size={100}
        className="mb-5"
      />
      <Title className="mb-4">404</Title>
      <p className="mb-5">{t('common.error404')}</p>
      <Button
        btnType="secondary"
        onClick={() => history.push('/')}
      >
        {t('common.home')}
      </Button>
    </Wrapper>
  );
};

export default NotFoundScreen;

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 5rem;
`;
